import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-filter-panel',
  standalone: true,
  imports: [CommonModule, DrawerModule, ButtonModule],
  template: `
    <p-drawer
      [(visible)]="visible"
      (visibleChange)="visibleChange.emit($event)"
      position="right"
      [style]="{ width: 'min(440px, 95vw)' }"
      styleClass="sp-filter-drawer"
      [modal]="true"
    >
      <ng-template pTemplate="header">
        <div class="filter-drawer-title">
          <i class="ri-equalizer-3-line" aria-hidden="true"></i>
          <span>{{ title }}</span>
        </div>
      </ng-template>
      <ng-content />

      <ng-template pTemplate="footer">
        <div class="filter-footer">
          <p-button
            type="button"
            label="Limpar"
            severity="secondary"
            [outlined]="true"
            icon="fas fa-undo"
            styleClass="filter-clear-button"
            (onClick)="onClearClick($event)"
          />
          <p-button
            type="button"
            label="Aplicar"
            icon="fas fa-check"
            (onClick)="applyFilters.emit()"
          />
        </div>
      </ng-template>
    </p-drawer>
  `,
  styles: [`
    .filter-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.5rem;
      width: 100%;
    }
    .filter-footer p-button {
      flex: 1 1 0;
    }
    .filter-drawer-title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--sp-text, #f1f5f9);
      font-size: 15px;
      font-weight: 700;
    }
    .filter-drawer-title i {
      color: var(--sp-primary, #3b82f6);
      font-size: 18px;
    }
  `]
})
export class FilterPanelComponent {
  @Input()  visible = false;
  @Output() visibleChange   = new EventEmitter<boolean>();
  @Output() applyFilters    = new EventEmitter<void>();
  @Output() clearFilters    = new EventEmitter<void>();
  @Input()  title = 'Filtros';

  onClearClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.clearFilters.emit();
  }
}
